var _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1457",
    "data-name": "Group 1457",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.916,
    height: 22.916,
    viewBox: "0 0 22.916 22.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 11.458,
    cy: 11.458,
    r: 11.458,
    fill: "#ffc905"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    transform: "translate(6.386 7.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    transform: "translate(7.973)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    fill: "#242424"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M3005.807,479s.971,5.217,7.124,5.217a7.088,7.088,0,0,0,7.286-5.217h-14.41Z",
    transform: "translate(-3001.598 -464.789)",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction1);
export default __webpack_public_path__ + "static/media/reaction1.76b421714084b59dd9ffb15ab2bcaf22.svg";
export { ForwardRef as ReactComponent };